import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import ComparatorReducer from '../redux/comparatorSlice';
import ConfigReducer from '../redux/configSlice';
import { RecursivePartial } from '../utils/recursivePartialType';

export const rootReducer = combineReducers({
  config: ConfigReducer,
  comparator: ComparatorReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type InitialRootState = RecursivePartial<RootState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
